<template>
  <div class="card-box">
    <div class="int-info" v-if="int">
      <img class="int-cover" :src="int.Cover">
      <div class="int-name">{{ int.InductionName }}</div>
      <div class="int-describe">{{ int.Description }}</div>
    </div>

    <div class="card-content">
      <img class="road" ref="road" :src="roadBackgroud">
      <div class="codes" ref="codes">
        <div class="code fadeIn" v-for="(code, i) in list" :key="code.Guid">
          <div class="code-white">
            <div class="code-center">
              <div class="code-box" ref="codeBox">
                <div class="code-content" @click="openUrl(code)">
                  <div class="code-info">
                    <svg class="icon-svg code-icon" v-if="code.isSubmited">
                      <use xlink:href="#icon-duihao" />
                    </svg>
                    <svg class="icon-svg code-icon" v-else>
                      <use :xlink:href="code.icon" />
                    </svg>
                  </div>
                  <div class="code-title ellipsis2">{{ code.Title }}</div>
                </div>
                <div class="code-line"></div>

                <a-tooltip title="帮助指引">
                  <div class="code-help" @click.stop="chooseHelp(code)" v-if="code.configJson?.helpContent">?</div>
                </a-tooltip>
              </div>
            </div>
          </div>
        </div>

        <div class="pageIcons" v-if="pages.length > 1">
          <div class="last-page" @click="changePage(currentPage - 1)" v-if="currentPage > 1">
            <img class="last-page-text" :src="pageIcons.lastText">
            <img class="last-page-icon" :src="pageIcons.lastIcon">
          </div>
          <div class="next-page" @click="changePage(currentPage + 1)" v-if="currentPage < pages.length">
            <img class="next-page-text" :src="pageIcons.nextText">
            <img class="next-page-icon" :src="pageIcons.nextIcon">
          </div>
        </div>
      </div>

      <div class="pages" ref="pages" v-if="pages.length > 1">
        <div class="page-item" :class="{ active: i + 1 == currentPage }" v-for="(item, i) in pages" :key="i"
          @click="changePage(i + 1)">
          <img class="page-icon" :src="int.Cover">
          <span>第{{ i + 1 }}页</span>
        </div>
      </div>
    </div>

    <CodeIframe :iframeUrl="iframeUrl" @closeIframeBox="iframeUrl = ''" v-if="iframeUrl" />
    <HelpBox :id="helpId" @close="helpId = ''" v-if="helpId"></HelpBox>
  </div>
</template>


<script>
import CodeIframe from "@/components/list/CodeIframe.vue";
import HelpBox from "@/components/list/HelpBox.vue";

export default {
  components: {
    CodeIframe, HelpBox
  },
  name: "list_item",
  props: {
    int: Object
  },
  data() {
    return {
      roadBackgroud: require("@/assets/images/list/card/road.png"),
      pageIcons: {
        nextIcon: require("@/assets/images/list/card/next-page.gif"),
        nextText: require("@/assets/images/list/card/next-page.png"),
        lastIcon: require("@/assets/images/list/card/last-page.gif"),
        lastText: require("@/assets/images/list/card/last-page.png"),
      },

      iframe_backcolor: '#ffffff00',
      iframeUrl: '',
      helpId: '',

      list: [],
      userInfo: null,

      pages: [],
      currentPage: 1,
      pageSize: 7,
    }
  },
  async mounted() {
    let { userInfo } = this.$store.state;
    this.userInfo = userInfo;

    //分页 
    const allCodes = this.int.allcode;
    const maxPage = Math.ceil(allCodes.length / this.pageSize);
    let pages = [];
    for (let i = 0; i < maxPage; i++) {
      pages.push(i + 1);
    }
    this.pages = pages;
    this.changePage(1);

    this.$nextTick(() => {
      const road = this.$refs.road;
      road.addEventListener('load', this.setCodesSize);

      window.addEventListener('resize', this.setCodesSize);
    });
  },
  methods: {
    setCodesSize() {
      this.$nextTick(() => {
        const road = this.$refs["road"];
        const codes = this.$refs["codes"];
        if (!road) return;
        if (!codes) return;

        const roadWidth = road.offsetWidth;
        const roadHeight = road.offsetHeight;

        codes.style.width = roadWidth + 'px';
        codes.style.height = roadHeight + 'px';
        codes.style.left = road.offsetLeft + "px";
        codes.style.top = road.offsetTop + "px";

        road.removeEventListener('load', this.setCodesSize);

        const codeList = Array.from(codes.children).filter(child => child.className.indexOf('code') > -1);
        const codeCount = codeList.length;

        for (let i = 0; i < codeList.length; i++) {
          const code = codeList[i];
          const codeWidth = 90 + 10 * i;
          const codeHeight = 20 + 3 * i;

          code.style.width = `${codeWidth}px`;
          code.style.height = `${codeHeight}px`;;

          let codeLeft = 0;
          let codeTop = 0;

          if (i == 0) {
            codeLeft = -25;
            codeTop = 0;
          }
          else if (i == codeCount - 1) {
            codeLeft = roadWidth - code.offsetWidth / 2 - 50;
            codeTop = roadHeight - code.offsetHeight / 2 - 22;
          }
          else {
            const onewidth = roadWidth / (codeCount - 1);
            const oneheight = roadHeight / (codeCount - 1);

            codeLeft = (onewidth * i) * ((i + 8) / (codeCount + 8)) - code.offsetWidth / 2 + 40;
            codeTop = (oneheight * i) * ((i + 8) / (codeCount + 8)) - code.offsetHeight / 2 + 10;
          }
          code.style.left = `${codeLeft}px`;
          code.style.top = `${codeTop}px`;
        }

        const codeBox = Array.from(codes.querySelectorAll('.code-box'));
        for (let i = 0; i < codeBox.length; i++) {
          codeBox[i].style.height = `${350 - 70 * ((i + 1) % 3)}px`;
        }
      })
    },

    //打开
    openUrl(code) {
      let token = this.userInfo.token;

      if (code.ProjectCode == 'kb') this.iframe_backcolor = '#ffffff';
      if (code.ProjectCode == "rpa" || code.ProjectCode == 'bookClass') {
        let url = code.address.replace("${token}", token)
        window.open(url);
      }
      else this.iframeUrl = code.phoneIframe;
    },
    //切换页码
    changePage(page) {
      this.currentPage = page;
      this.list = this.int.allcode.slice((page - 1) * this.pageSize, page * this.pageSize);

      this.setCodesSize();
    },
    //选择帮助
    chooseHelp(code) {
      this.helpId = code.configJson.helpContent.id;
    }
  },
  //beforeUnmount() {},
}
</script>

<style scoped lang="scss">
.card-box {
  position: relative;
  text-align: center;
  height: 100%;

  .return-icon {
    position: absolute;
    top: 0;
    left: 10px;
    font-size: 40px;
    cursor: pointer;
    transition: all .3s ease;
    padding: 7px;
    border-radius: 7px;
    color: #ffffff;
    margin-right: 10px;
    z-index: 10;

    &:hover {
      color: #e86b99;
    }
  }

  .int-info {
    position: absolute;
    left: 20px;
    top: calc(50% - 200px);
    width: 300px;
    color: #ffffff;
    text-align: center;

    .int-cover {
      width: 100%;
      max-height: 300px;
      opacity: 0.7;
    }

    .int-name {
      margin-top: 20px;
      font-size: 36px;
      background: linear-gradient(to bottom, #E67291, #E18F6C);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .int-describe {
      font-size: 17px;
      margin-top: 10px;
    }
  }

  .card-content {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding-top: 300px;
    padding-left: 260px;

    .road {
      max-width: calc(100% - 40px);
      max-height: calc(100% - 20px);
      user-select: none;
    }

    .codes {
      position: absolute;
      user-select: none;

      .code {
        border-radius: 50%;
        background-color: #6C61C6;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;

        &:nth-child(odd) {
          .code-white {
            .code-center {
              background-color: #E47E81;

              .code-box {
                .code-content {
                  background-color: #E47E81;

                  .code-info {
                    .code-icon {
                      color: #E47E81;
                    }
                  }
                }

                .code-line {
                  background-color: #E47E81;
                }
              }
            }
          }
        }

        .code-white {
          border-radius: 50%;
          background-color: #ffffff;
          width: 70%;
          height: 70%;
          display: flex;
          justify-content: center;
          align-items: center;

          .code-center {
            width: 70%;
            height: 70%;
            background-color: #6C61C6;
            border-radius: 50%;

            .code-box {
              position: absolute;
              left: calc(50% - 50px);
              bottom: 50%;
              height: 300px;
              width: 100px;

              .code-content {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100px;
                border-radius: 24px;
                background-color: #6C61C6;
                cursor: pointer;
                transition: all .3s ease;

                &:hover {
                  transform: scale(1.1);

                  .code-info {
                    opacity: .8;
                  }
                }

                .code-info {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 80%;
                  height: 80%;
                  background-color: #ffffff;
                  border-radius: 24px;
                  box-shadow: 0px 5px 7px #a1a0a0 inset;
                  position: relative;
                  transition: all .3s ease;

                  .code-icon {
                    font-size: 40px;
                    color: #6C61C6;
                    filter: drop-shadow(1px 4px 3px #a1a0a0);
                  }
                }

                .code-title {
                  position: absolute;
                  top: -40px;
                  left: -5px;
                  font-size: 15px;
                  width: calc(100% + 10px);
                  text-align: center;
                  line-height: 1.2;
                }
              }

              .code-line {
                width: 4px;
                height: calc(100% - 100px);
                background-color: #6C61C6;
                position: absolute;
                left: calc(50% - 2px);
                bottom: 0;
              }

              .code-help {
                position: absolute;
                left: calc(50% - 15px);
                top: -87px;
                font-size: 20px;
                transition: all 0.3s ease;
                cursor: pointer;
                width: 30px;
                height: 30px;
                background-color: #ffffff1f;
                border-radius: 50%;
                z-index: 19;

                &:hover {
                  color: #E47E81;
                }
              }
            }
          }
        }
      }

      .pageIcons {
        .last-page {
          position: absolute;
          top: 37px;
          left: 10px;
          cursor: pointer;

          &:hover {
            .last-page-text {
              opacity: 1;
            }
          }

          .last-page-text {
            position: absolute;
            top: 45px;
            left: 88px;
            opacity: 0;
            transition: all 0.3s ease;
          }
        }

        .next-page {
          position: absolute;
          bottom: 10px;
          right: 250px;
          cursor: pointer;

          &:hover {
            .next-page-text {
              opacity: 1;
            }
          }

          .next-page-text {
            position: absolute;
            top: -36px;
            left: -36px;
            opacity: 0;
            transition: all 0.3s ease;
          }

          .next-page-icon {
            width: 180px;
          }
        }
      }
    }
  }

  .pages {
    position: absolute;
    left: 20px;
    bottom: 40px;
    display: flex;
    align-items: center;

    .page-item {
      padding: 0px 10px;
      margin: 0 5px;
      font-size: 15px;
      height: 40px;
      display: flex;
      align-items: center;
      border-radius: 7px;
      transition: all 0.3s ease;
      cursor: pointer;
      position: relative;
      background-color: hsla(0, 0%, 73%, 0.31);

      .page-icon {
        height: 24px;
        width: 24px;
        margin-right: 5px;
      }

      &.active {
        background-color: #E47E81;
        color: #ffffff;
      }
    }
  }
}
</style>